/* eslint-disable jsdoc/check-param-names */
import React from 'react';
// prettier-ignore
import { IconButton, Dialog, DialogActions, DialogContent, DialogTitle, Typography, Button } from '@mui/material';
import { CloseSharp } from '@mui/icons-material';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import { buttonsTheme } from './_theme.jsx';

/**
 * Template for the AMC popups
 * @param {boolean} showTitleBanner Show the orange banner with popup title
 * @param {string} title The title of the popup
 * @param {React.ReactElement} content The content of the popup
 * @param {React.ReactElement} button The buttons of the popup
 * @param {function(): void} handleCloseDialog Callback when clicking on the upper right close icon
 * @param {object} style An object with additional css properties in the format used by MUI
 * @returns {React.ReactElement}
 * @class
 */
// prettier-ignore
export const BasePopup = ({ showTitleBanner = true, title, content, button, largeWidth = false, handleCloseDialog, style }) => {

	let titleComponent;
	if(showTitleBanner) {
		titleComponent = <DialogTitle className='base-popup-title-container'>
			<div style={{ color: '#FFF', fontSize: '20px', fontWeight: 400, marginRight: '5vw' }}>{title}</div>
			<IconButton onClick={handleCloseDialog} color='iconOnPrimary'>
				<CloseSharp style={{color: '#FFF !important'}} />
			</IconButton>
		</DialogTitle>;
	} else {
		titleComponent =
			<IconButton onClick={handleCloseDialog} style={{position: 'absolute', top: '31px', right: '34px'}}>
				<CloseSharp />
			</IconButton>;
	}

	return <ThemeProvider theme={buttonsTheme}>
		<Dialog
			onClose={handleCloseDialog}
			PaperProps={{
				style: {
					minHeight: '40vh',
					width: '60vw',
					overflowY: 'visible',
					...style
				},
			}}
			maxWidth={largeWidth ? 'xl' : undefined}
			fullWidth={largeWidth}
			open={true}
			sx={{ width: "100%", height: '100%', padding: '4vw' }}>
			{titleComponent}
			<DialogContent sx={{ overFlowY: 'visible' }}>
				{content}
			</DialogContent>
			<DialogActions sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.5vh' }}>
				{button}
			</DialogActions>
		</Dialog>
	</ThemeProvider>;
}

export const ConfirmButton = ({ text, onClick }) => {
    return (
        <Button color="primary" variant="contained" onClick={onClick}>
            {text}
        </Button>
    );
};

export const PopupSubtitle = ({ subtitle, caption = '' }) => {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '1vh',
                alignSelf: 'left',
            }}
        >
            <Typography variant="body1">{subtitle}</Typography>
            {caption.length > 0 ? <Typography variant="caption">{caption}</Typography> : null}
        </div>
    );
};
